<app-template-text
  (onblur)="onblur.emit()"
  [required]="required"
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [label]="label"
/>
